module.exports = "<b-form-textarea v-bind=\"$attrs\" max-rows=\"6\" rows=\"3\" v-model=\"value\"></b-form-textarea>\n"